<template>
   <v-container fluid fill-height>
      <v-layout align-center justify-center>
         <v-flex xs12 sm8 md4>
            <v-card class="elevation-12" flat>
               <v-toolbar dark color="primary">
                  <v-toolbar-title>{{ isRegister ? stateObj.register.name : stateObj.login.name }}
                     form</v-toolbar-title>
               </v-toolbar>
               <v-card-text>
                  <form ref="form" @submit.prevent="isRegister ? register() : login()">
                     <v-text-field v-model="userName" name="userName" label="userName" type="text" placeholder="userName"
                        required></v-text-field>

                     <v-text-field v-model="password" name="password" label="Password" type="password"
                        placeholder="password" required></v-text-field>
                     <a href="#" class="text-body-2 font-weight-regular">Forgot Password?</a>
                     <v-text-field v-if="isRegister" v-model="confirmPassword" name="confirmPassword"
                        label="Confirm Password" type="password" placeholder="confirm password" required></v-text-field>
                     <div class="red--text"> {{ errorMessage }}</div>
                     <v-btn type="submit" class="mt-2" color="primary" variant="outlined" block value="log in">{{
                        isRegister ?
                        stateObj.register.name : stateObj.login.name }}</v-btn>
                     <div class="mt-2">
                        <p class="text-body-2">Don't have an account? <a href="#">Sign Up</a></p>
                     </div>

                  </form>

               </v-card-text>
            </v-card>

         </v-flex>
      </v-layout>
   </v-container>
</template>

<script>

export default {
   name: "App",
   data() {
      return {
         userName: null,
         password: null,
         confirmPassword: null,
         isRegister: false,
         errorMessage: null,
         stateObj: {
            register: {
               name: 'Register',
               message: 'Aleady have an Account? Click here Login.'
            },
            login: {
               name: 'Login',
               message: 'Don\'t have an account? Click here Register.'
            }
         }
      };
   },
   methods: {
      login() {
         let userName = this.userName;
         let clientId = process.env.VUE_APP_CLIENT_ID;
         let password = this.password;

         this.$store
            .dispatch("login", { userName, password, clientId })
            .then((response) => this.onLoginSuccess(response))
            .catch((err) => {
               this.onLoginFail(err);
            });
      },
      onLoginSuccess() {
         //this.handleLoader(false);         
         this.$router.push("/account");
      },
      onLoginFail(err) {
         //this.handleLoader(false);
         if (err && err.errors) {
            err.errors.forEach((element) => {
               this.errors.add({
                  scope: "login",
                  field: element.field,
                  msg: element.msg,
               });
            });
         }
      },
      register() {
         if (this.password == this.confirmPassword) {
            this.isRegister = false;
            this.errorMessage = "";
            this.$refs.form.reset();
         }
         else {
            this.errorMessage = "password did not match"
         }
      }
   },
   computed: {
      toggleMessage: function () {
         return this.isRegister ? this.stateObj.register.message : this.stateObj.login.message
      }
   }
};
</script>